import React, { useState } from "react";
import { Button } from "components/atoms";
import "../index.scss";

interface TransitionWarningProps {
  theme: "light" | "dark";
  onStartNewSession: () => void;
  onCancel: () => void;
  onDoNotShowAgain: (checked: boolean) => void;
}

export const TransitionWarning: React.FC<TransitionWarningProps> = ({
  theme,
  onStartNewSession,
  onCancel,
  onDoNotShowAgain
}) => {
  const [doNotShowChecked, setDoNotShowChecked] = useState(false);

  const handleDoNotShowChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setDoNotShowChecked(checked);
    onDoNotShowAgain(checked);
  };

  const handleStartNewSession = () => {
    onStartNewSession();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className={`chat-message ai-message`}>
      <div className="message-content">
        <div className="message-bubble">
          <strong>Start New Session?</strong>
          <br />
          <br />
          You're about to begin a new session to focus on a selected practice question. This will close your current session, and the conversation history will no longer be available. Do you want to continue?
          <br />
          <br />
          <div className="transition-warning-checkbox">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={doNotShowChecked}
                onChange={handleDoNotShowChange}
                className="checkbox-input"
              />
              <span className="checkmark"></span>
              <span className="checkbox-label">Do not show this again</span>
            </label>
          </div>
          <div className="idle-button-container">
            <Button
              label="Cancel"
              icon={false}
              type="filter"
              styles="ai-review-btn ai-review-btn-filter"
              onClick={handleCancel}
            />
            <Button
              label="Start New Session"
              icon={false}
              type="score"
              styles="ai-review-btn"
              onClick={handleStartNewSession}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
